import React from 'react';
import './Contact.css';
import msgi from '../../msgicon.png';

const Contact = () => {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");

    const formData = new FormData(event.target);
    formData.append("access_key", "283ab5c4-bfd9-4ab3-b42f-72b1bfe40f36"); 
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className='contact'>
      <div className="contact-col">
        <h3>
          Drop your message here <img src={msgi} alt="message icon" />
        </h3>
        <p>
          We're here to help! Whether you have questions about <strong>admissions</strong>, <strong>courses</strong>, <strong>campus facilities</strong>, or any other inquiries, feel free to reach out to us.
        </p>
        <p>
          Our dedicated team is available to assist you with the information and support you need. You can contact us via <strong>phone</strong>, <strong>email</strong>, or by <strong>visiting our campus</strong> during working hours.
        </p>
        <p>We look forward to hearing from you!</p>

        <ul>
          <li>Contact@gietuniversity.edu</li>
          <li>
            +91-8118053001, +91-7735745535, 06857-250170, 06857-250172
          </li>
          <li>
            Gunupur, At – Gobriguda, Po- Kharling, Dist. - Rayagada, Odisha - India, 765022
          </li>
        </ul>
      </div>

      <div className='contact-col'>
        <form onSubmit={onSubmit}>
          <label>Your name</label>
          <input type="text" name="name" placeholder="Enter your name" required />

          <label>Email</label>
          <input type="email" name="email" placeholder="Enter your email" required />

          <label>Phone Number</label>
          <input type="tel" name="phone" placeholder="Enter your mobile number" required />

          <label>Write your message here</label>
          <textarea name="message" rows="6" placeholder="Enter your message" required></textarea>

          <button type="submit" className="btn dark-btn">Submit now</button>
        </form>
        <span>{result}</span>
      </div>
    </div>
  );
};

export default Contact;
